import React from "react";
import "./CompositionCircle.css";

const CompositionCircle = ({
    element,
    percentage,
    isEmpty = false,
    hideValue = false,
    size = 90,
}) => {
    const strokeWidth = 2;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    // Скрытое значение рисуем полным кольцом, чтобы оно не выдавало долю.
    const dashOffset = hideValue
        ? 0
        : circumference * (1 - percentage / 100);

    const formatChemicalFormula = (text) => {
        return text.replace(
            /([A-Za-zа-яА-Я])(\d+)/g,
            (match, letter, number) => {
                return `${letter}<sub>${number}</sub>`;
            }
        );
    };

    if (isEmpty) {
        return (
            <div className="composition-circle empty">
                <svg width={size} height={size}>
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        stroke="rgba(255, 255, 255, 0.3)"
                        strokeWidth={strokeWidth}
                        fill="none"
                        strokeDasharray="4 4"
                    />
                </svg>
            </div>
        );
    }

    return (
        <div
            className="composition-circle"
            style={{ width: size, height: size }}
        >
            <div
                className="circle-background"
                style={{ backgroundColor: "4971FF" }}
            >
                <span
                    className="element-name"
                    dangerouslySetInnerHTML={{
                        __html: formatChemicalFormula(element),
                    }}
                />
                <span className="element-percentage">
                    {hideValue ? "—" : `${percentage.toFixed(1)}%`}
                </span>
            </div>
            <svg width={size} height={size} className="circle-progress">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="white"
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={dashOffset}
                    transform={`rotate(${size / 2} ${size / 2})`}
                />
            </svg>
        </div>
    );
};

export default CompositionCircle;
